<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Responsables Indicadores</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nuevo Responsable Indicador</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="codigo_responsable_indicador" label="Codigo Responsable"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field v-model="nombre_responsable_indicador" label="Nombre Responsable"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 v-show="valida">
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                    </div>
                                </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>


                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdResponsable}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>                    
 

                    </v-card>            
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="responsable_indicador"
        :search="search"
        class="elevation-1"
    >     
 
                 <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        edit
                    </v-icon>
                    <template v-if="item.estado_responsable_indicador">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            block
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            check
                        </v-icon>
                    </template>
                </template>
                 <template slot="items" slot-scope="props">
                    <td>{{ props.item.codigo_responsable_indicador }}</td>
                    <td>{{ props.item.nombre_responsable_indicador }}</td>
                    <td>
                        <div v-if="props.item.estado_responsable_indicador">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                responsable_indicador:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Codigo Responsable', value: 'codigo_responsable_indicador' },
                    { text: 'Nombre Responsable', value: 'nombre_responsable_indicador' , sortable: false},
                    { text: 'Estado', value: 'estado_responsable_indicador', sortable: false }
                ],
                search: '',
                editedIndex: -1,
                codigo_responsable_indicador: '',
                nombre_responsable_indicador: '',
                estado_responsable_indicador:true,
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adNombre_Responsable:'',
                adIdResponsable:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nuevo Responsable Indicador' : 'Actualizar Responsable Indicador'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
    },
    methods:
    {
		listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Responsables_Indicadores/Listar').then(function(response){
				//console.log(response);
				me.responsable_indicador=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},

		editItem (item) {
            this.codigo_responsable_indicador=item.codigo_responsable_indicador;
			this.nombre_responsable_indicador=item.nombre_responsable_indicador;
            this.estado_responsable_indicador=item.estado_responsable_indicador;
            this.editedIndex=1;
			this.dialog = true
		},

		deleteItem (item) {
		const index = this.responsable_indicador.indexOf(item)
		confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
			this.codigo_responsable_indicador="";
			this.nombre_responsable_indicador="";
			this.estado_responsable_indicador="";
			this.editedIndex=-1;
		},

		guardar () {
			if(this.validar()){
				return;
			}
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};   
            if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Responsables_Indicadores/Actualizar',{
					'codigo_responsable_indicador': me.codigo_responsable_indicador,
					'nombre_responsable_indicador': me.nombre_responsable_indicador,
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Responsables_Indicadores/Crear',{
					'codigo_responsable_indicador': me.codigo_responsable_indicador,
                    'nombre_responsable_indicador': me.nombre_responsable_indicador,
                    'estado_responsable_indicador':me.estado_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});
			}
		},
		validar(){
			this.valida=0;
			this.validaMensaje=[];
			if(this.nombre_responsable_indicador.length < 3 || this.nombre_responsable_indicador.length > 100){
				this.validaMensaje.push("El Nombre_responsable_indicador debe tener mas de 3 caracteres y menos de 100 caracteres");
			}
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },
        activarDesactivarMostrar(accion,item){
            this.adModal=1;
            this.adIdResponsable=item.codigo_responsable_indicador;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
            this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
            this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Responsables_Indicadores/Activar/'+this.adIdResponsable,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre_Responsable="";
            me.adIdResponsable="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Responsables_Indicadores/Desactivar/'+this.adIdResponsable,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adNombre_Responsable="";
                me.adIdResponsable="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });

        }
    }        
}
</script>